import { render, staticRenderFns } from "./location.vue?vue&type=template&id=68025390&scoped=true"
import script from "./location.vue?vue&type=script&setup=true&lang=js"
export * from "./location.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68025390",
  null
  
)

export default component.exports